<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="500px"
      append-to-body
      :before-close="handleCancel"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="100px" :rules="rules" @submit.native.prevent>
        <el-form-item label="标签名称：" prop="name">
          <el-input v-model.trim="form.name" placeholder="请输入标签名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="标签类型：" prop="tagTypeId">
          <el-select v-model="form.tagTypeId" placeholder="请选择标签类型" clearable>
            <el-option
              v-for="item in tagTypeList"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import to from 'await-to'
import { tagInfoQuery, tagSave, tagUpdate } from '@/api/system'
export default {
  name: 'AddModal',
  props: {
    tagTypeList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      title: '添加标签',
      form: {},
      rules: {
        name: [{ required: true, message: '请输入标签名称', trigger: 'blur' }],
        tagTypeId: [{ required: true, message: '请选择标签类型', trigger: 'change' }],
      },
    }
  },
  methods: {
    show(row) {
      this.form = {}
      if (row && row.id) {
        this.title = '编辑标签'
        this.handleGetTagInfo(row.id)
      } else {
        this.title = '添加标签'
      }
      this.visible = true
    },
    async handleGetTagInfo(id) {
      const [res, err] = await to(tagInfoQuery({ id }))
      if (err) return this.$message.warning(err.msg)
      this.form = res.data
    },
    async handleConfirm() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          if (this.form.id) {
            const [, err] = await to(tagUpdate({ ...this.form }))
            if (err) return this.$message.warning(err.msg)
            this.$message.success('编辑成功')
          } else {
            const [, err] = await to(tagSave({ ...this.form }))
            if (err) return this.$message.warning(err.msg)
            this.$message.success('添加成功')
          }
          this.handleCancel()
          this.$emit('success')
        }
      })
    },
    handleCancel() {
      this.$refs['form'].clearValidate()
      this.form = {}
      this.visible = false
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body {
  display: flex;
  justify-content: center;
  .el-input,
  .el-select {
    width: 280px;
  }
}
::v-deep .el-dialog__footer {
  .el-button {
    width: 100px;
  }
}
</style>
